import BaseModel from "./_BaseModel";

export default class HargaBarang extends BaseModel {
    public readonly ucode?: string;
    public kode?: string;
    public harga_brg?: number;
    public aktif?: boolean = true;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
}